import React from 'react';

const Footer = () => (
  <footer className="border-t border-gray-200 py-4 text-center text-sm text-gray-500 bg-white">
    &copy; {new Date().getFullYear()} Aromas Datasheet. Todos los derechos reservados | 
    Desarrollado por <a href="https://lucasbonomo.com" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Lucas Bonomo</a>
  </footer>
);

export default Footer;
